import React from 'react';
import {
  type DocumentConfig,
  type DocumentFormState,
} from '../documentModalHelpers';

interface NotesTabProps {
  isActive: boolean;
  currentDocumentId: string | number | null;
  formData: DocumentFormState;
  setFormData: React.Dispatch<React.SetStateAction<DocumentFormState>>;
  config: DocumentConfig;
  isDarkMode: boolean;
  isCompactMobileDoc: boolean;
}

export function NotesTab({
  isActive,
  currentDocumentId,
  formData,
  setFormData,
  config,
  isDarkMode,
  isCompactMobileDoc,
}: NotesTabProps) {
  if (!isActive) return null;

  return (
    <div className={`grid gap-6 ${isCompactMobileDoc ? 'grid-cols-1' : 'grid-cols-2'}`}>
      {config.fields.showNotes && (
        <div>
          <label className={`block text-xs font-semibold uppercase tracking-wide mb-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'
            }`}>
            Notes to Customer
          </label>
          <textarea
            rows={5}
            value={formData.notes || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, notes: e.target.value }))}
            className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm ${isDarkMode
              ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
              : 'bg-white border-gray-300 text-gray-900'
              }`}
            placeholder="Notes that will appear on the document..."
          />
        </div>
      )}

      {config.fields.showTermsConditions && (
        <div className="col-span-2">
          <label className={`block text-xs font-semibold uppercase tracking-wide mb-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'
            }`}>
            Terms & Conditions
          </label>
          <textarea
            rows={4}
            value={formData.terms_and_conditions || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, terms_and_conditions: e.target.value }))}
            className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm ${isDarkMode
              ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
              : 'bg-white border-gray-300 text-gray-900'
              }`}
            placeholder="Terms and conditions..."
          />
        </div>
      )}
    </div>
  );
}
